import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
  SidebarSeparator,
  Watermark,
} from "@motleyhand/design"
import { Link } from "@tanstack/react-router"
import TenantSelect from "./TenantSelect"
import DefinitionMenus from "./DefinitionMenus"
import FooterMenu from "@/app/sidebar/FooterMenu"
import RunsMenu from "@/app/sidebar/RunsMenu"
import { useMaybeTenant } from "@/auth"
import { AppLogo } from "@/ui"

export default function AppSidebar() {
  const tenantSlug = useMaybeTenant()

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              className="px-0 group-data-[collapsible=icon]:px-0!"
              render={
                <Link to="/">
                  <AppLogo
                    size={18}
                    variant="full"
                    className="group-data-[state=collapsed]:hidden"
                  />
                  <AppLogo
                    size={18}
                    variant="glyph"
                    className="group-data-[state=expanded]:hidden"
                  />
                </Link>
              }
            />
          </SidebarMenuItem>
        </SidebarMenu>
        <SidebarSeparator className="ml-0" />
        {tenantSlug && (
          <>
            <TenantSelect />
            <SidebarSeparator className="ml-0" />
          </>
        )}
      </SidebarHeader>
      <SidebarContent>
        {tenantSlug && (
          <SidebarGroup>
            <RunsMenu />
            <DefinitionMenus />
          </SidebarGroup>
        )}
      </SidebarContent>
      <SidebarFooter>
        <FooterMenu />
      </SidebarFooter>
      <Watermark
        glyph="corner-scatter"
        className="group-data-[collapsible=icon]:hidden"
        flipX
      />
      <SidebarRail />
    </Sidebar>
  )
}
